import React from 'react';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';

const NotFound = () => {

    const {t} = useTranslation()
    return (
        <Typography
            sx={{
                padding: '10px'
            }}
            variant={'body2'}
        >
            {t('notFound')}
        </Typography>
    );
};

export default NotFound;